{
  "title": "Psychic Crush (UA)",
  "source": "Unearthed Arcana 66 - Fighter, Rogue, and Wizard",
  "levelAndSchool": "6th-level enchantment",
  "level": 6,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S",
  "duration": "1 minute",
  "description": [
    "You overload the mind of one creature you can see within range, filling its psyche with discordant emotions. The target must make an Intelligence saving throw. On a failed save, the target takes 12d6 psychic damage and is stunned for 1 minute. On a successful save, the target takes half as much damage and isn’t stunned.",
    "The stunned target can make an Intelligence saving throw at the end of each of its turns. On a successful save, the spell ends on the target."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
